import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import { flexCenter } from '../commonUI/cssClasses';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        ...flexCenter,
      }}
    >
      <Typography variant='h3'>
        {t('pageNotFound', { ns: 'common' })}
      </Typography>
    </Box>
  );
};

export default NotFound;
